import { ERP } from '../_base/endpoint';
import axios from 'axios';
import global from '../../common/utility/global';

class establecimientoService {

    /******* QUERIES ******/

    async listarTodoPorIdEntidad(idEntidad) {
        const response = await axios
            .get(`${ERP}administracion/establecimiento/todo-por-id-entidad/${idEntidad}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });

        return response;
    };

    async principales() {
        const response = await axios
            .get(`${ERP}administracion/establecimiento/principales`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });

        return response;
    };

    async paginacion(filter) {
        const response = await axios
            .get(`${ERP}administracion/establecimiento/paginacion?${global.formatParameter(filter)}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });

        return response;
    };

    async obtenerPorId(id) {
        const response = await axios
            .get(`${ERP}administracion/establecimiento/${id}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    async excel(filter) {
        const response = await axios
            .get(`${ERP}administracion/establecimiento/excel?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };


    async pdf(filter) {
        const response = await axios
            .get(`${ERP}administracion/establecimiento/pdf?${global.formatParameter(filter)}`, { responseType: 'blob', })
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };

    /******* TRANSACCIONES ******/

    async registrar(data) {
        const response = await axios
            .post(`${ERP}administracion/establecimiento`, data)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    };

    async modificar(data) {
        const response = await axios
            .put(`${ERP}administracion/establecimiento`, data)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    };

    async eliminar(data) {
        const response = await axios
            .put(`${ERP}administracion/establecimiento/eliminar`, data)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    };

    async activar(data) {
        const response = await axios
            .put(`${ERP}administracion/establecimiento/activar`, data)
            .then(response => {
                return response;
            })
            .catch(error => {
                console.log(error);
                return error.response ? error.response : {};
            });
        return response;
    };

    async listarPorIdEntidad(idEntidad) {
        const response = await axios
            .get(`${ERP}administracion/establecimiento/por-entidad/${idEntidad}`)
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };
}

export default new establecimientoService();